module.exports = __webpack_public_path__ + "media/main_mov_v2.89dc4d4e.mp4";